import { css } from "@linaria/core";
import cx from "classnames";
import React, { useEffect } from "react";
import { colors, fonts, spacings } from "@ui/Theme";
import { Link, useLocation } from "react-router";
import t from "../../../i18n";

export const ApplicationAnchors = () => {
  const location = useLocation();
  useEffect(() => {
    // scroll behavior is defined in css
    if (location.hash.slice(1).length > 0) document.querySelector(location.hash)?.scrollIntoView();
  }, [location.hash]);

  return (
    <aside className={applicationSettingNavigation}>
      <Link
        to={location.pathname + "#data-import"}
        className={cx({ active: location.hash === "data-import" })}
      >
        {t("customization.section.data_import.title")}
      </Link>
      <br />
      <Link
        to={location.pathname + "#live-data-workflow"}
        className={cx({ active: location.hash === "live-data-workflow" })}
      >
        {" "}
        {t("administration.application.api_key.title")}
      </Link>
      <br />
      <Link
        to={location.pathname + "#data-display"}
        className={cx({ active: location.hash === "data-display" })}
      >
        {" "}
        {t("customization.section.data_display.title")}
      </Link>
      <br />
      <Link
        to={location.pathname + "#fault-analysis"}
        className={cx({ active: location.hash === "fault-analysis" })}
      >
        {" "}
        {t("customization.section.failure_analysis.title")}
      </Link>
      <br />
      <Link
        to={location.pathname + "#fault-migration"}
        className={cx({ active: location.hash === "fault-migration" })}
      >
        {" "}
        {t("customization.section.failure_analysis.migration.short_title")}
      </Link>
      <br />
      <Link
        to={location.pathname + "#digital-twin"}
        className={cx({ active: location.hash === "digital-twin" })}
      >
        {" "}
        {t("customization.section.digital_twin.title")}
      </Link>
      <br />
      <Link
        to={location.pathname + "#algorithm"}
        className={cx({ active: location.hash === "algorithm" })}
      >
        {" "}
        {t("setup.diagnosis.algorithm.title")}
      </Link>
      <br />
      <Link
        to={location.pathname + "#refresh-sources"}
        className={cx({ active: location.hash === "refresh-sources" })}
      >
        {t("customization.demo_environment.keep_demos_updated")}
      </Link>
      <br />
      <Link
        to={location.pathname + "#advanced-features"}
        className={cx({ active: location.hash === "advanced-features" })}
      >
        {" "}
        {t("customization.section.advanced_features.title")}
      </Link>
      <br />
      <Link
        to={location.pathname + "#terminology"}
        className={cx({ active: location.hash === "terminology" })}
      >
        {" "}
        {t("customization.section.terminology.title")}
      </Link>
      <br />
      <Link to={location.pathname + "#link"} className={cx({ active: location.hash === "link" })}>
        {" "}
        {t("customization.section.link.title")}
      </Link>
      <br />
      <Link
        to={location.pathname + "#legals"}
        className={cx({ active: location.hash === "legals" })}
      >
        {" "}
        {t("customization.section.legals.title")}
      </Link>
    </aside>
  );
};

export const applicationSettingNavigation = css`
  :global() {
    html {
      scroll-padding-top: calc(var(--primary-header-height) + ${spacings.l});
      scroll-behavior: smooth;
    }
  }

  position: sticky;
  top: calc(var(--primary-header-height) + 48px);

  @media (max-width: 1024px) {
    display: none;
  }

  a {
    white-space: nowrap;
    font: ${fonts.body2};
    color: ${colors.carbon900};

    &.active {
      color: ${colors.lightNitrogen500_Main};
    }
  }
`;
